module.exports = __webpack_public_path__ + "static/media/cofco.7b44dc94.png";